/**
 * Flags de UI temporales.
 * RDA: oculto mientras se despliega la corrección RIPS; reactivar cuando se retome IHCE.
 */
export const RDA_UI_ENABLED = false;
